import { Dimensions, Platform } from 'react-native';

// the design width (portrait) for mobile phone
// // https://www.screensizes.app/?compare=iphone
const kBaseWidth = 375;
const kBaseHeight = 812;

// const kBaseWidth = 393;
// const kBaseHeight = 852;

// the design width (landscape) for ipad
const kBaseWidthIpad = 1366;

const kScreenWidth =
  Platform.OS === 'web' && window.screen.availWidth
    ? window.screen.availWidth
    : Dimensions.get('window').width;

const kScreenHeight =
  Platform.OS === 'web' && window.screen.availHeight
    ? window.screen.availHeight
    : Dimensions.get('window').height;

type Options = { factor?: number; round?: boolean; ignoreHeight?: boolean };

export type PixelScaleFn = (value: number, options?: Options) => number;

export const spxFactory =
  (
    targetWidth: number = kScreenWidth,
    targetHeight: number = kScreenHeight,
    maxScaleFactor: number = Number.POSITIVE_INFINITY,
  ) =>
  (value: number, options?: Options) => {
    const factor = Math.min(
      options?.factor ?? targetWidth / kBaseWidth,
      options?.factor ?? targetHeight / kBaseHeight,
      maxScaleFactor,
    );

    return value * factor;
  };

/**
 * Converts a pixel value in base design to be scaled appropriately in target
 * device w/ smaller or larger screen dimensions.
 * @description default pixel scaler function
 * @param value the pixel value in base design
 * @param [factor] the optional custom scale factor
 * @returns converted pixel value
 */
export const spx: PixelScaleFn = spxFactory();

export const spxIdentity: PixelScaleFn = (value: number) => value;

export const spxForTablet: PixelScaleFn = value => {
  const width = Math.max(kScreenWidth, kScreenHeight);
  return (width / kBaseWidthIpad) * value;
};

export const spxForMobileHighDPI = spxFactory(kScreenWidth, kScreenHeight, 1.1);

const mobileWeb = spxFactory(kScreenWidth, kScreenHeight, 1);

export const spxForMobileWeb2: PixelScaleFn = (value, options) =>
  Math.floor(mobileWeb(value, { ...options }));

export const spxForMobileWeb = mobileWeb;
